/*
 Created by qing on 2020/12/29
 Des: 快捷入口
 */
import BaseConfig from "../BaseConfig";
import {CONFIG_TYPE__QUICK_ENTRY, TODO_SHOW_TYPE__WIDE} from "../type";


class QuickEntryConfig extends BaseConfig {
  constructor() {
    super()

    this.h = 7

    this.minW = 10
    this.minH = 7

    this.pH = 7
    this.pW = 60

    this.pMinW = 10
    this.pMaxW = 60
    this.pMinH = 3
    this.pMaxH = 200

    this.menuList = []

    this.showType = TODO_SHOW_TYPE__WIDE
  }

  get title() {
    return this.configName || QuickEntryConfig._title
  }

  set title(content) {
    this.configName = content
  }

}

QuickEntryConfig._title = '快捷入口'
QuickEntryConfig.type = CONFIG_TYPE__QUICK_ENTRY

QuickEntryConfig.prototype.configType = QuickEntryConfig.type
QuickEntryConfig.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    menuList: this.menuList,
    showType: this.showType
  }
}
QuickEntryConfig.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.menuList = opts.menuList
  this.showType = opts.showType

  if (opts.hasOwnProperty('pH')) this.pH = opts.pH
  if (opts.hasOwnProperty('pW')) this.pW = opts.pW
  if (opts.hasOwnProperty('pX')) this.pX = opts.pX
  if (opts.hasOwnProperty('pY')) this.pY = opts.pY

  if (opts.showType === TODO_SHOW_TYPE__WIDE) {
    this.minW = 10
    this.minH = 7
  } else {
    this.minW = 10
    this.maxW = 20
    this.minH = 8
    this.maxH = 15
  }
}
QuickEntryConfig.prototype.getValue = function () {
}

export default QuickEntryConfig
